import { render, staticRenderFns } from "./PurchaseSuit.vue?vue&type=template&id=5c901b40"
import script from "./PurchaseSuit.vue?vue&type=script&lang=js"
export * from "./PurchaseSuit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports